// extracted by mini-css-extract-plugin
export default {"stat":"HeadlineStats__stat-w3pw","stats":"HeadlineStats__stats-vrzm"};